<div class="container">
  <app-catalog-passport></app-catalog-passport>
</div>
